export default __webpack_public_path__ + "static/media/swingleft_groupphoto.ca913676.jpg";